import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class StatusconfigurationDataService {
    constructor(private dataProvider: DataService) {
    }

    getStatusList(language: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetStatusConfiguration,language).toPromise();
    }

    async saveStatusConfiguration(mapData: any): Promise<Observable<any>> {
        return this.dataProvider.Post(Urls.UpdateStatusConfiguration, mapData);

    }

}